var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-picker__icons"},[_vm._l((_vm.icons),function(icon){return [_c('Icon',{key:icon.name,attrs:{"name":icon.name},on:{"select":_vm.select}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }